import PropTypes from 'prop-types';
import star from 'public/static/images/dealer_pages/star.svg';
import halfStar from 'public/static/images/dealer_pages/half-star.svg';
import emptyStar from 'public/static/images/dealer_pages/empty-star.svg';
import goldStar from 'public/static/images/dealer_pages/gold-full-star.svg';
import goldHalfStar from 'public/static/images/dealer_pages/gold-half-star.svg';

const Star = ({ type, className, isGold = false }) => {
  return (
    <div data-testid="star" className={`star ${type} ${className}`}>
      <style jsx>{`
        .star {
          width: 18px;
          height: 18px;
          margin-left: 3px;
          background-repeat: no-repeat;
          background-size: 18px 18px;
        }

        .star:first-child {
          margin-left: 0;
        }

        .full {
          background-image: url(${isGold ? goldStar : star});
        }

        .half {
          background-image: url(${isGold ? goldHalfStar : halfStar});
        }

        .empty {
          background-image: url(${emptyStar});
        }
      `}</style>
    </div>
  );
};

Star.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  isGold: PropTypes.bool,
};

export default Star;
